import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'

const { FIELD_LISTS } = DEFAULT

const babylon: PartnerConfig = {
  branding: {
    logo: [
      {
        src: '/images/babylon.png',
        alt: 'Babylon logo',
      },
    ],
  },
  config: {
    id: 'babylon-health',
    name: 'Babylon',
    appName: DEFAULT.APPNAMES.BABYLON,
    acceptLanguage: 'en-GB',
    codes: {
      membership: 'babylon',
    },
    partnerUrlSlug: 'babylon',
    steps: DEFAULT.STEPS,
    fields: [
      [DEFAULT.FIELDS.EMAIL],
      [
        DEFAULT.FIELDS.FIRST_NAME,
        DEFAULT.FIELDS.LAST_NAME,
        DEFAULT.FIELDS.PASSWORD,
        DEFAULT.FIELDS.DATE_OF_BIRTH,
        DEFAULT.FIELDS.PHONE_COUNTRY_CODE,
        DEFAULT.FIELDS.PHONE_NUMBER,
        DEFAULT.FIELDS.POSTCODE,
      ],
      FIELD_LISTS.familyMemberFields.GBR,
    ],
  },
  content: {
    'en-GB': {
      steps: [
        {
          title: 'Welcome to Babylon',
          stepperLabel: 'Welcome',
          copy: [
            'You can get fast medical advice and have video consultations with English speaking doctors if you feel unwell.',
            'Fill in your details below to register with Babylon today.',
          ],
          productFeatures: [
            {
              icon: 'ChatFilled',
              title: 'Check your symptoms quickly and easily',
              description:
                'Check your symptoms instantly to get the most appropriate health information and next steps.',
            },
            {
              icon: 'PeopleMedicalSpecialist',
              title: 'Talk to a doctor, 24/7',
              description:
                'Talk to a doctor at any time of the day or night, directly from your mobile. Appointments are normally available within two hours.',
            },
            {
              icon: 'Medication',
              title: 'Prescriptions sent to a local pharmacy of your choice',
              description:
                'Have a prescription sent electronically to your chosen pharmacy for collection*, or get it delivered free to your home or workplace. *If abroad, available only in specific locations, and subject to the availability of the pharmacy.',
            },
          ],
        },
        {
          title: 'Registration',
          stepperLabel: 'Registration',
          copy: [
            'Just a few more details are needed from you to complete your Babylon registration.',
          ],
        },
        {
          title: 'Add family member',
          stepperLabel: 'Family',
          copy: [
            'Before you finish, don‘t forget to add your family members for a complete piece of mind.',
          ],
        },
        {
          title: 'Download the app',
          stepperLabel: 'Thank You',
          copy: [
            'Download and sign into the app to book a Babylon Video Appointment 24/7, available at no cost through Royal Wolverhampton Trust. Don‘t receive Babylon through RWT? Access our Chatbot and Healthcheck for free.',
          ],
          imgUrl: '/images/babylon-ios-app.png',
          cta: {
            label: 'Questions? Contact us →',
            link: 'https://support.babylonhealth.com/hc/en-us',
            showDownloadButtons: true,
          },
          showPromotionBox: true,
        },
      ],
      footerLinks: DEFAULT.FOOTERLINKS.GBR,
    },
  },
}

export default babylon
